import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import PropTypes from "prop-types";
import {getCorAleatoria} from "../../../utils/functions";
import {ResponsiveContainer, PieChart, Pie, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell} from 'recharts';

@inject("store")
@observer
export class CustomPieChart extends Component {
    static propTypes = {
        data: PropTypes.PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.arrayOf(PropTypes.object)
        ]),
        dataKey: PropTypes.string,
        nameKey: PropTypes.string,
        onClick: PropTypes.func
    };

    static defaultProps = {
        dataKey: "value",
        nameKey: "nome",
        width: 600,
        height: 300
    };

    constructor(props) {
        super(props);
    }

    showChart = () => {
        return this.props.data && this.props.data.length > 0;
    }

    showNoDataFound = () => {
        return this.props.data && this.props.data.length === 0;
    }

    getLabel = (value) => {
        return `${(value.percent * 100).toFixed(2).replace(/\./g, ',')}%`;
    }

    render() {
        const props = {
            pieChart: {
                width: this.props.width,
                height: this.props.height
            },
            pie: {
                data: this.props.data,
                dataKey: this.props.dataKey,
                nameKey: this.props.nameKey,
                onClick: this.props.onClick
            }
        };

        return (
            <div>
                { this.showChart() &&
                    <div className="container-graph">
                        <ResponsiveContainer>
                            <PieChart { ...props.pieChart }>
                                <Pie { ...props.pie } fill={getCorAleatoria()}
                                        label={(value) => this.getLabel(value)} outerRadius={"65%"}>
                                    {
                                        this.props.data.map((data, index) => {
                                            return <Cell key={data} fill={getCorAleatoria(index)}/>
                                        })
                                    }
                                </Pie>
                                <Tooltip/>
                                <Legend />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                }
                { this.showNoDataFound() &&
                    <span>Nenhum resultado encontrado</span>
                }
            </div>
        )
    }
}

Pie.propTypes = {
    data: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.arrayOf(PropTypes.object)
    ])
}
